import { jsx } from "react/jsx-runtime";
import { ResetButton as ResetBtn } from "../../../../ResetButton.js";
function ResetButton(props) {
  const { onClick: onClickCb, ...rest } = props;
  return /* @__PURE__ */ jsx(
    ResetBtn,
    {
      onClick: (e) => {
        e.stopPropagation();
        onClickCb?.(e);
      },
      ...rest
    }
  );
}
export {
  ResetButton
};
//# sourceMappingURL=ResetButton.js.map
